import type { LedgerSwitchValue } from '../../components/ledger-links/ledger-hrefs';

// Reports first: it is the landing tab and what the section is opened for.
// Accounts and Journals are the configuration and audit surfaces behind it.
// Nothing derives from this order (the default tab is set explicitly, and the
// report sub-tabs have their own list), so it is presentation only.
export const LEDGER_TABS = [
  { id: 'reports', label: 'Reports' },
  { id: 'accounts', label: 'Accounts' },
  { id: 'journals', label: 'Journals' },
  { id: 'assets', label: 'Assets' },
] as const;

export type LedgerTabId = (typeof LEDGER_TABS)[number]['id'];

const VALID_LEDGER_TAB_IDS = new Set<string>(LEDGER_TABS.map((t) => t.id));

export function isValidLedgerTabId(value: string | null): value is LedgerTabId {
  return value !== null && VALID_LEDGER_TAB_IDS.has(value);
}

// A trust ledger holds client money, never the firm's own property, so it has
// no fixed-asset register and the Assets tab is not offered on it at all.
const TRUST_LEDGER_TABS = LEDGER_TABS.filter((t) => t.id !== 'assets');

export function tabsForLedger(value: LedgerSwitchValue): readonly (typeof LEDGER_TABS)[number][] {
  return value === 'trust' ? TRUST_LEDGER_TABS : LEDGER_TABS;
}
